import { gql } from '@apollo/client';

export const UPDATE_VENDOR_REPRESENTATIVE = gql`
  mutation UpdateVendorRepresentative(
    $vendorRepresentativeUpdate: VendorRepresentativeUpdateInput!
    $vendorRepresentativeId: String!
    $vendorId: String!
  ) {
    updateVendorRepresentative(
      vendorRepresentativeUpdate: $vendorRepresentativeUpdate
      vendorRepresentativeId: $vendorRepresentativeId
      vendorId: $vendorId
    ) {
      firstName
      lastName
    }
  }
`;
